import React from 'react';
import { Box, Toolbar } from '@mui/material';
import { AzulNavBar } from '../Navbar/Navbar';
import { Sidebar } from '../Sidebar';
import { Outlet, useLocation } from 'react-router-dom';
import styles from './Layout.module.css';

export function Layout() {
  const location = useLocation();
  const layoutRoutes = [
    {
      path: '/Documents',
      name: 'Settings',
      showSideBar: true,
      meta: {
        pageClass: 'documentsPage',
      },
    },
    {
      path: '/Templates',
      name: 'Settings',
      showSideBar: true,
      meta: {
        pageClass: 'templatesPage',
      },
    },
    {
      path: '/settings',
      name: 'Settings',
      showSideBar: false,
      meta: {
        pageClass: 'settingsPage',
      },
    },
  ];

  const currentPage = layoutRoutes.find(({ path }) => path === location.pathname);
  const {
    showSideBar,
    meta: { pageClass },
  } = currentPage || { showSideBar: true, meta: { pageClass: 'main' } };
  const drawerWidth = 88;

  return (
    <Box>
      <AzulNavBar label='DocGenius' notificationsCount={0} navbarWidth={showSideBar ? 80 : 0} />
      {showSideBar && <Sidebar sidebarWidth={drawerWidth} />}
      <Box
        component='main'
        className={styles[pageClass]}
        ml={`${showSideBar ? drawerWidth : 0}px`}
        sx={{ flexGrow: 1, p: 3 }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
